<template>
  <div class="verification-form-product-risk">
    <div class="verification-cdd-form__questions-list">
      <h3 class="verification-cdd-form__title">
        {{ "verification-form-product-risk.title" | globalize }}
      </h3>

      <verification-form-question
        v-model="form.qus01"
        @input="former.setAttr('productRisk.qus01', form.qus01)"
        :question-message="
          'verification-form-product-risk.qus-01' | globalize"
        :error-message="getFieldErrorMessage('form.qus01')"
        :disabled="isDisabled"
      />

      <verification-form-question
        v-model="form.qus02"
        @input="former.setAttr('productRisk.qus02', form.qus02)"
        :question-message="
          'verification-form-product-risk.qus-02' | globalize"
        :error-message="getFieldErrorMessage('form.qus02')"
        :disabled="isDisabled"
      />

      <verification-form-question
        v-model="form.qus03"
        @input="former.setAttr('productRisk.qus03', form.qus03)"
        :question-message="
          'verification-form-product-risk.qus-03' | globalize"
        :error-message="getFieldErrorMessage('form.qus03')"
        :disabled="isDisabled"
      />

      <verification-form-question
        v-model="form.qus04"
        @input="former.setAttr('productRisk.qus04', form.qus04)"
        :question-message="
          'verification-form-product-risk.qus-04' | globalize"
        :error-message="getFieldErrorMessage('form.qus04')"
        :disabled="isDisabled"
      />

      <verification-form-question
        v-model="form.qus05"
        @input="former.setAttr('productRisk.qus05', form.qus05)"
        :question-message="
          'verification-form-product-risk.qus-05' | globalize"
        :error-message="getFieldErrorMessage('form.qus05')"
        :disabled="isDisabled"
      />

      <verification-form-question
        v-model="form.qus06"
        @input="former.setAttr('productRisk.qus06', form.qus06)"
        :question-message="
          'verification-form-product-risk.qus-06' | globalize"
        :error-message="getFieldErrorMessage('form.qus06')"
        :disabled="isDisabled"
      />
    </div>
  </div>
</template>

<script>
import { VerificationCDDFormer } from '@/js/formers/VerificationCDDFormer'
import VerificationFormQuestion from './VerificationFormQuestion'
import FormMixin from '@/vue/mixins/form.mixin'
import { required } from '@validators'

export default {
  name: 'verification-form-product-risk',
  components: { VerificationFormQuestion },
  mixins: [FormMixin],
  props: {
    former: {
      type: VerificationCDDFormer,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      form: {
        qus01: this.former.attrs.productRisk.qus01,
        qus02: this.former.attrs.productRisk.qus02,
        qus03: this.former.attrs.productRisk.qus03,
        qus04: this.former.attrs.productRisk.qus04,
        qus05: this.former.attrs.productRisk.qus05,
        qus06: this.former.attrs.productRisk.qus06,
      },
    }
  },
  validations () {
    let form = {}
    Object.keys(this.form).forEach(key => { form[key] = { required } })

    return { form }
  },
}
</script>
